'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reducers = require('../reducers');

var _reducers2 = _interopRequireDefault(_reducers);

var _redux = require('redux');

var _promiseMiddleware = require('./promiseMiddleware');

var _promiseMiddleware2 = _interopRequireDefault(_promiseMiddleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var middlewares = process.env.NODE_ENV === 'development' ? [(0, _redux.applyMiddleware)(_promiseMiddleware2.default)] : [(0, _redux.applyMiddleware)(_promiseMiddleware2.default)];
// import DevTools from 'bp_config/devtools';


var initialize = function initialize() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var store = (0, _redux.createStore)(_reducers2.default, initialState, _redux.compose.apply(undefined, middlewares));

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', function () {
      var nextReducer = require('../reducers/index');
      store.replaceReducer(nextReducer);
    });
  }
  return store;
};

exports.default = initialize;


//////////////////
// WEBPACK FOOTER
// ./src/config/store.js
// module id = 386
// module chunks = 0